import { render } from "./main-menu-button.vue?vue&type=template&id=aba9ccce"
import script from "./main-menu-button.vue?vue&type=script&lang=js"
export * from "./main-menu-button.vue?vue&type=script&lang=js"
script.render = render

export default script